import { memo } from "react";
import { WARRANTY_OPTIONS } from "services/api/sales/listings/consts";
import { MarketplaceDetails } from "services/api/sales/listings/types";
import { ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { InfoCard, Section } from "./primitives";

interface Props {
  details?: MarketplaceDetails | null;
}

// Sekcija "Jamstvo" — isti raspored kao WarrantySection na unosu: jamstvo i
// oba čipa svaki u svojoj koloni.
const ListingWarranty: React.FC<Props> = ({ details }) => {
  const warranty = details?.warrantyCode
    ? WARRANTY_OPTIONS.find((o) => o.value === details.warrantyCode)?.text ?? details.warrantyCode
    : null;

  return (
    <Section title="Jamstvo">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-3">
        <div>
          <InfoCard label="Jamstvo" value={warranty} />
        </div>

        <div className="flex items-center">
          <ChipToggle label="Produljeno jamstvo" selected={!!details?.extendedWarranty} readOnly />
        </div>

        <div className="flex items-center">
          <ChipToggle label="G1 klub jamstvo" selected={!!details?.g1ClubWarranty} readOnly />
        </div>
      </div>
    </Section>
  );
};

export default memo(ListingWarranty);
